$ = jQuery.noConflict();

var Postuler_Video = {
	init:function(){
		$(".postulez-grid .grid-element.image").on("click", function(e){
			if(e.target.classList.contains("is-playing")){
				e.target.classList.remove("is-playing");
				e.target.querySelector("video").pause();
			}else{
				e.target.classList.add("is-playing");
				e.target.querySelector("video").play();
			}
		})
	
	}
	
}

$(document).ready(function(){

	if($(".postulez-grid .grid-element.image").length){
		Postuler_Video.init();
	}
});